import { checkPath } from '@ow/utils'

const polys = (
  opts = {
    cacheKey: 'objectId',
  }
) => {
  const render =
    (AMap, amap, layer) =>
    (data = [], config = {}) => {
      const { cacheKey } = opts
      const { type = 'Polygon', onClick, ...commonConfig } = config

      if (!layer.cache[type]) {
        layer.cache[type] = {}
      }

      const renderData = data.filter((item) => {
        // 过滤已渲染的点
        if (item[cacheKey] && layer.cache[type][item[cacheKey]]) {
          return false
        }

        // Polygon path校验
        if (type === 'Polygon') {
          return checkPath(item.path)
        }

        // Polyline lineString/MultiLineString校验
        if (type === 'Polyline') {
          if (item.path) {
            return checkPath(item.path) || item.path.every(checkPath)
          }
        }

        return true
      })

      // if (type === 'MultiPolygon') {
      //   return item.geometry.coordinates[0]
      // }

      const polysList = renderData.map((item) => {
        const { path, ...customConfig } = item
        const geometry = new AMap[type]({
          path,
          ...commonConfig,
          ...customConfig,
        })

        if (typeof onClick === 'function') {
          geometry.on('click', (e) => {
            onClick({ ...e, originData: item })
          })
        }

        return geometry
      })

      layer.overlayGroup.addOverlays(polysList)

      renderData.forEach((item) => {
        layer.cache[type][item[cacheKey]] = true
      })
    }
  const show = (layer) => () => {
    layer.overlayGroup.show()
  }
  const hide = (layer) => () => {
    layer.overlayGroup.hide()
  }
  const clear = (layer) => () => {
    layer.overlayGroup.clearOverlays()
    layer.cache = {}
  }
  const setApis = (AMap, amap) => ({
    initPolys: (layer) => {
      layer.cache = {}
      layer.overlayGroup = new AMap.OverlayGroup()
      amap.add(layer.overlayGroup)

      // ---- exposed interface ---------
      layer.render = render(AMap, amap, layer)
      layer.hide = hide(layer)
      layer.show = show(layer)
      layer.clear = clear(layer)
      // -------------------------------
    },
  })
  return {
    amapPlugins: [],
    setApis,
  }
}

export default polys
